import React from 'react';

const PoweredByGiphy = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={79}
    height={9}
    viewBox="0 0 53 6"
    {...props}
  >
    <defs>
      <path id="giphy-a" d="M.203.01h5.254V6H.203z" />
      <path id="giphy-c" d="M0 5.99h52.224V0H0z" />
    </defs>
    <g fill="none" fillRule="evenodd" opacity=".3">
      <g fill="currentColor">
        <path d="M.418 3.536h.793c.691 0 .688-1.14 0-1.14H.418v1.14zm0 .42v.875H0V1.98c.4 0 .811-.004 1.211-.004 1.248 0 1.252 1.97 0 1.979H.418z" />
        <path d="M3.76 4.472c.651 0 .924-.5.924-1.046 0-.525-.277-1.07-.916-1.082-.605 0-.93.46-.93 1.082.007.505.276 1.046.923 1.046m1.338-1.054c0 .77-.43 1.474-1.338 1.474-.909 0-1.338-.72-1.338-1.47 0-.867.556-1.494 1.345-1.494.894.005 1.331.72 1.331 1.49M8.21 4.835h-.37l-.348-1.006-.287-.956-.288.96-.344 1.002h-.367l-.95-2.854h.468l.666 2.194.676-2.194h.27l.69 2.194.651-2.194h.467zM11.474 4.83H9.541V1.982h1.922v.444H9.96v.77h1.443v.422H9.96v.766h1.514zM12.432 2.397V3.43h.796c.348 0 .5-.24.5-.508 0-.257-.152-.525-.496-.525h-.8zM14.27 4.83h-.49l-.796-.985h-.553v.985h-.419V1.977c.407 0 .811.004 1.219.004.605 0 .923.452.923.933 0 .406-.195.806-.71.887l.78.948.046.082zM16.642 4.83h-1.933V1.982h1.922v.444h-1.504v.77h1.443v.422h-1.443v.766h1.515zM17.595 4.39h.576c.64 0 .908-.512.897-1.013-.011-.48-.28-.96-.897-.96h-.576V4.39zm.576-2.409c.893 0 1.3.696 1.312 1.4.015.721-.396 1.45-1.312 1.45h-.99V1.98h.99zM21.33 4.407h.786c.231 0 .553-.081.553-.395 0-.305-.31-.443-.55-.443h-.789v.838zm0-1.245h.79c.313 0 .47-.135.47-.358 0-.2-.16-.411-.474-.411h-.786v.769zm.786-1.18c.497 0 .889.248.889.813 0 .24-.116.456-.363.566.315.102.445.44.445.656 0 .622-.456.814-.971.814h-1.2V1.98h1.2zM24.404 3.24l.744-1.259h.504v.021l-1.039 1.66v1.169h-.418V3.662l-1.01-1.66v-.02h.497z" />
      </g>
      <g>
        <g transform="translate(26.66)">
          <mask fill="#fff">
            <use xlinkHref="#giphy-a" />
          </mask>
          <path
            fill="currentColor"
            d="M4.38 1.85a1.728 1.728 0 0 0-1.23-.494c-.877 0-1.447.551-1.447 1.661 0 .73.362 1.63 1.447 1.63.284 0 .73-.057 1.038-.292v-.73H2.827V2.37h2.63v2.52C5.12 5.612 4.181 6 3.142 6 1.011 6 .203 4.5.203 3.017S1.126.011 3.15.011c.746 0 1.407.162 2.115.915l-.885.924z"
          />
        </g>
        <mask id="giphy-d" fill="#fff">
          <use xlinkHref="#giphy-c" />
        </mask>
        <path
          fill="currentColor"
          d="M32.981 5.846h1.516V.173H32.98zM37.113 2.96h1.092c.423 0 .639-.323.639-.696 0-.373-.224-.714-.639-.714h-1.092v1.41zm0 1.354v1.532H35.59V.173h2.615c1.446 0 2.162.956 2.162 2.066 0 1.16-.724 2.059-2.162 2.075h-1.092zM44.507 5.854V3.706h-1.939v2.148h-1.523V.181h1.523v2.156h1.939V.18h1.507v5.673zM49.347 2.118L50.51.173h1.715v.073l-2.138 3.339v2.261h-1.523V3.585L46.516.237V.173h1.716z"
        />
      </g>
    </g>
  </svg>
);
PoweredByGiphy.displayName = 'PoweredByGiphy';

export default PoweredByGiphy;
